import { render } from "./EnBreadcrumbs.vue?vue&type=template&id=6e1a26f2&ts=true"
import script from "./EnBreadcrumbs.vue?vue&type=script&setup=true&lang=ts"
export * from "./EnBreadcrumbs.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"Shared/components/navigation/EnBreadcrumb/EnBreadcrumbs.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6e1a26f2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6e1a26f2', __exports__)) {
    api.reload('6e1a26f2', __exports__)
  }
  
  module.hot.accept("./EnBreadcrumbs.vue?vue&type=template&id=6e1a26f2&ts=true", () => {
    api.rerender('6e1a26f2', render)
  })

}


export default __exports__